import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { VerifiedEmailPage } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { UserService } from 'src/app/services/user.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import environment from 'src/environments/environment';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss'],
    imports: [NgIf],
})
export class VerifyEmailComponent extends PageComponent implements OnInit {
  public override pageData: VerifiedEmailPage = <VerifiedEmailPage>{};

  public success = false;

  public email: string | null = '';

  public failureReason = '';

  public resent = false;

  public resendError = false;

  public notFoundError = false;

  public verifyUrl: string | null = null;

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    private readonly route: ActivatedRoute,
    private readonly user: UserService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    const uuid = String(routeParams.get('uuid'));
    const token = String(routeParams.get('token'));

    this.verifyUrl = `${environment.apiHost}/${environment.apiPath}/email/verify/${uuid}/${token}`;
  }
}
